import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Select,
  Text,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Image,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { IoMdClose } from "react-icons/io";

const RoomBillPrintModal = ({
  isOpen,
  onClose,
  data,
  onOpen,
  roomBillData,
}) => {
  console.log(data, "data");

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const print = () => {
    handlePrint();
  };
  const handleClose = () => {
    onClose();
  };
  const scroll = "inside";

  return (
    <Modal
      width="full"
      size="7xl"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      scrollBehavior={scroll}
    >
      <ModalOverlay />
      <ModalContent bg="#f9f1e3">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text>Bill Data- {data?.name}</Text>
          <Button colorScheme="red" onClick={handleClose}>
            <IoMdClose />
          </Button>
        </ModalHeader>
        <ModalBody>
          {roomBillData ? (
            <Card
              mt={10}
              textAlign="center"
              boxShadow="dark-lg"
              ref={componentRef}
              width="794px"
              mx="auto"
            >
              <Text
                color="purple"
                fontSize="18px"
                fontFamily="sans-serif"
                mt={5}
              >
                Room Bill Report
              </Text>
              <CardHeader
                display="flex"
                justifyContent="center"
                flexDirection="column"
                alignItems="center"
                gap={5}
                p={4}
                boxShadow="md"
              >
                <Box
                  color="purple"
                  fontSize="18px"
                  fontFamily="sans-serif"
                  textAlign="center"
                >
                  {data.map((item) => (
                    <>
                      <Image
                        alignItems="center"
                        src={item.imageUrl}
                        w="220px"
                        h="100px"
                        mb={2}
                      />
                      <Text>{item.name}</Text>
                      <Text>{item.adress}</Text>
                      <Text>{item.phoneNo}</Text>
                      <Text>{item.website}</Text>
                      <Text>Email id:{item.email}</Text>
                      <Text>Gst No:{item.gstNo}</Text>
                    </>
                  ))}
                </Box>
              </CardHeader>
              <CardBody
                display="flex"
                justifyContent="space-between"
                p={1}
                textAlign="left"
              >
                <TableContainer width="full">
                  <Table size="xsm" variant="striped" colorScheme="teal">
                    <TableCaption>Room Data</TableCaption>
                    <Thead>
                      <Tr>
                        <Th fontSize="6px">Names</Th>
                        <Th fontSize="6px">Rate</Th>
                        <Th fontSize="6px">Bill No</Th>
                        {/* <Th fontSize='6px'>Date</Th> */}
                        <Th fontSize="6px">Address</Th>
                        <Th fontSize="6px">Phone No</Th>
                        <Th fontSize="6px">Company Name</Th>
                        <Th fontSize="6px">Company GST No</Th>
                        <Th fontSize="6px">Check-In</Th>
                        <Th fontSize="6px">Check-In Time</Th>
                        <Th fontSize="6px">Check-Out</Th>
                        <Th fontSize="6px">Check-Out Time</Th>
                        <Th fontSize="6px">Room No</Th>

                        <Th fontSize="6px">Rate</Th>
                        <Th fontSize="6px">Discount</Th>
                        <Th fontSize="6px">CGST</Th>
                        <Th fontSize="6px">SGST</Th>
                        <Th fontSize="6px">Service Charge</Th>
                        <Th fontSize="6px">Total</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {roomBillData.map((item, index) => (
                        <Tr key={index}>
                          <Td fontSize="6px">{item.name}</Td>
                          <Td fontSize="6px">{item.rate}</Td>
                          <Td fontSize="6px">{item.billNo}</Td>
                          {/* <Td fontSize='6px'>{item.date}</Td> */}
                          <Td fontSize="6px">{item.address}</Td>
                          <Td fontSize="6px">{item.phoneNo}</Td>
                          <Td fontSize="6px">{item.companyName}</Td>
                          <Td fontSize="6px">{item.gstNo}</Td>
                          <Td fontSize="6px">{item.checkIn}</Td>
                          <Td fontSize="6px">
                            {item.checkInTime ? item.checkInTime : null}
                          </Td>
                          <Td fontSize="6px">{item.checkOut}</Td>
                          <Td fontSize="6px">
                            {item.checkOutTime ? item.checkOutTime : null}
                          </Td>
                          <Td fontSize="6px">{item.roomNo}</Td>

                          <Td fontSize="6px">{item.registration}</Td>
                          <Td fontSize="6px">{item.discount}</Td>
                          <Td fontSize="6px">{item.cgst}</Td>
                          <Td fontSize="6px">{item.sgst}</Td>
                          <Td fontSize="6px">{item.serviceCharge}</Td>
                          <Td fontSize="6px">{item.total}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </CardBody>
            </Card>
          ) : (
            ""
          )}

          <Box
            display="flex"
            flexDirection="row"
            justifyContent="end"
            alignItems="center"
            gap="3"
          >
            <Button as="b" colorScheme="blue" onClick={print}>
              Print
            </Button>
            <Button as="b" colorScheme="blue" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default RoomBillPrintModal;
